"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldTypeValues = void 0;
exports.CustomFieldTypeValues = ['string', 'boolean', 'integer', 'float', 'date', 'url'];
